/**
 * Custom three-pointed star icon — distinct from the Mercedes-Benz trademark
 * (open lines instead of solid star, cyan accent, dashboard's font/stroke
 * style). Visual cousin, not a copy.
 */
import type { CSSProperties } from 'react'

export default function MercedesIcon({ size = 28, color = 'currentColor', style }: {
  size?: number; color?: string; style?: CSSProperties
}) {
  const s = size
  const r = s * 0.46                  // outer radius
  const c = s / 2                     // centre
  // 3 points at 90° (up), 210° (lower-left), 330° (lower-right)
  const angles = [-90, 150, 30]       // degrees
  const tips = angles.map(a => {
    const rad = (a * Math.PI) / 180
    return [c + r * Math.cos(rad), c + r * Math.sin(rad)]
  })
  return (
    <svg viewBox={`0 0 ${s} ${s}`} width={s} height={s} style={style}
         fill="none" stroke={color} strokeWidth={s * 0.085}
         strokeLinecap="round">
      <circle cx={c} cy={c} r={r * 1.04} strokeWidth={s * 0.05} opacity={0.45} />
      {tips.map(([x, y], i) => (
        <line key={i} x1={c} y1={c} x2={x} y2={y} />
      ))}
      <circle cx={c} cy={c} r={s * 0.05} fill={color} stroke="none" />
    </svg>
  )
}
